import { computed } from 'vue'

import { usePrivacyPolicyStore } from '@/stores/privacyPolicy'

export const fetchPrivacyPolicyStore = async () => {
  const privacyPolicyStore = usePrivacyPolicyStore()

  try {
    await privacyPolicyStore.fetchPrivacyPolicyData()
  } catch (error) {
    console.error('Error during fetching privacy policy data:', error)
  }
}

export const usePrivacyPolicyData = () => {
  const companyStore = usePrivacyPolicyStore()
  return computed(() => companyStore.getPrivacyPolicyData)
}
